import type { PendingTask } from '@/types/pendingTasks';

export interface PendingTaskTarget {
  path: string;
}

// Where a dashboard row routes, built from the task's type and reference ids.
// Routing is a frontend concern, so the deep link is constructed here (next to
// the app's routes) rather than handed down from the backend. Returns null when
// a task lacks the ids its destination needs.
export function resolvePendingTaskTarget(
  task: PendingTask
): PendingTaskTarget | null {
  const path = buildPendingTaskPath(task);
  return path ? { path } : null;
}

function buildPendingTaskPath(task: PendingTask): string | null {
  const { reference_ids: references, fund_id: fundId } = task;

  switch (task.task_type) {
    case 'convertible_maturity': {
      const companyId = references.company_id;
      if (!companyId) return null;
      return `/app/portfolio/${companyId}?section=captable&subsection=convertibles`;
    }
    case 'drawdown_payment':
    case 'drawdown_draft': {
      const drawdownId = references.drawdown_id;
      if (!drawdownId) return null;
      return `/app/funds/${fundId}/drawdowns/${drawdownId}/preview`;
    }
    case 'captable_transaction_approval': {
      const companyId = references.company_id;
      const assetTransactionId = references.asset_transaction_id;
      if (assetTransactionId) {
        if (!companyId) return null;
        return `/app/portfolio/${companyId}/asset-transactions/${assetTransactionId}`;
      }
      const transactionId = references.transaction_id;
      if (!companyId || !transactionId) return null;
      return `/app/portfolio/${companyId}/transactions/${transactionId}`;
    }
    default:
      return null;
  }
}
